<template>
  <div id="app">
    <Archives 
      :studio="studio" 
      :broadcasts="broadcasts" 
      :shows="shows" 
      :toolbar-enabled="enableArchivesToolbar"
      v-on:show-select="filterShowsById"
      v-on:date-select="filterDate"
    />
  </div>
</template>

<style lang="stylus">
body
  padding 0
  margin 0


#app
  font-family Arial, Helvetica, sans-serif, sans
  padding 0



body.archives-theme-basic

  // background none
  background #eee

body.archives-theme-krbx
  

  .archives
    
    background #eee
    
    .options-toolbar
      // background rgb(45, 48, 98)
      
      label
        color #fff

      select, input
        // border 2px solid rgba(255,255,255,0.4)
        // background rgba(0,0,0,0.2)
        // color #fff
        
        &:hover
          border-color rgba(255,255,255,0.7)
          background rgba(0,0,0,0.3)

    .aplayer
      // border-radius 4px
      
      .aplayer-pic
        // border 5px solid rgb(45, 48, 98)
        border-radius 3px
        
        .aplayer-button
          background rgba(255,255,255,1)
          border 8px solid rgba(255,255,255,1)

          .aplayer-fill
            fill #000
            border 2px solid 

body.archives-theme-dark

  background #000
  
  .archives

    .options-toolbar
      background #222

      select, input
        border 2px solid #555
        background #111
        color #fff
        
        &:hover
          border-color #777
          background #222

    .aplayer
      background #222
      
      .aplayer-body
        background #222
        
        .aplayer-info
          padding-left 20px !important
          
          .aplayer-music
            
            .aplayer-author
              color #777
              
            .aplayer-title
              color #fff

      .aplayer-pic
        border 0
        background-color transparent !important
          
      .aplayer-controller
        
        .aplayer-time
          color rgba(255,255,255,0)
          
          .aplayer-ptime
            color rgba(255,255,255,0.7)
          
          .aplayer-dtime
            color rgba(255,255,255,0.7)


      .aplayer-bar-wrap
        
        .aplayer-bar
          
          .aplayer-played
            
            .aplayer-thumb
              background #000 !important
              border 3px solid #fff !important


body.archives-theme-kmno
  background #fff
  // background rgb(45, 48, 98)
  
  .archives
      
    .options-toolbar
      background rgb(45, 48, 98)
      
      label
        color #fff

      select, input
        border 2px solid rgba(255,255,255,0.4)
        background rgba(0,0,0,0.2)
        color #fff
        
        &:hover
          border-color rgba(255,255,255,0.7)
          background rgba(0,0,0,0.3)

    .aplayer
      // background rgb(45, 48, 98)
      background rgb(45, 48, 98)
      // background #fff
      border-radius 4px
      
      .aplayer-pic
        border 5px solid rgb(45, 48, 98)

        background-color transparent !important
        .aplayer-button
          background rgb(45, 48, 98)
          border 8px solid rgb(45, 48, 98)
          
      .aplayer-body
        // background #fff
        background rgb(45, 48, 98)
        
        .aplayer-info
          padding-left 20px !important
          .aplayer-music
            .aplayer-author
              color rgba(255,255,255,0.6)
            .aplayer-title
              color rgba(255,255,255,1)
              
      .aplayer-controller
        
        .aplayer-time
          color rgba(255,255,255,0)
          
          .aplayer-ptime
            color rgba(255,255,255,0.7)
          
          .aplayer-dtime
            color rgba(255,255,255,0.7)


      .aplayer-bar-wrap
        
        .aplayer-bar
          
          .aplayer-played
            
            .aplayer-thumb
              background #000 !important
              border 3px solid #fff !important



</style>

<script type="text/javascript">

import axios from 'axios'

import Archives from './components/Archives.vue'

export default {
  name: 'ArchivesWebsite',
  props: {
    // msg: String
  },
  components: {
    Archives
  },
  data(){
    return { 
      studio: {},
      refreshInterval: null,
      broadcasts: [],
      shows: [],
      selected: {
        showId: null,
        showName: null,
      },
      URLPrefix: null,
      enableArchivesToolbar: true,
    }
  },
  methods: {
    filterShowsById(showId = null, shouldRefresh = true){
      this.selected.showId = showId
      if(shouldRefresh){
        this.refresh()
      }
    },
    filterShowsByName(showName = null, shouldRefresh = true){
      this.selected.showName = showName
      if(shouldRefresh){
        this.refresh()
      }
    },
    filterDate(date = null, shouldRefresh = true){
      this.selected.date = date
      if(shouldRefresh){
        this.refresh()
      }
    },
    refresh(){

      if(!this.URLPrefix){
        return
      }

      this.handleQueryStrings()

      let archiveOptions = '?x=1'

      if(this.selected.showId){
        archiveOptions += '&showId=' + this.selected.showId
      }

      if(this.selected.showName){
        archiveOptions += '&showName=' + this.selected.showName
      }

      if(this.selected.date){
        archiveOptions += '&date=' + encodeURIComponent(this.selected.date)
      }

      axios.get(this.URLPrefix + '/api/archives' + archiveOptions)
        .then((response) => {
          console.log(response)
          this.broadcasts = response.data.data
        })

      axios.get(this.URLPrefix + '/api/archives/shows-list')
        .then((response) => {
          console.log("Shows")
          console.log(response)
          this.shows = response.data.data
        })

    },

    getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },

    handleQueryStrings(){

      const showIdParam = this.getParameterByName('showId');
      const showNameParam = this.getParameterByName('showName');

      if(showIdParam){
        this.enableArchivesToolbar = false
        this.filterShowsById(showIdParam, false)
      }
      
      if(showNameParam){
        this.enableArchivesToolbar = false
        this.filterShowsByName(showNameParam, false)
      }

    },

    startRefreshInterval(){

      this.refreshInterval = setInterval(this.refresh, 10000)

    },

    applyThemeToBody(){

      let theme = "archives-theme-light"

      if(this.studio && this.studio.archives_theme){
        theme = 'archives-theme-' + this.studio.archives_theme
      }
      
      document.body.className = theme;
      
      return theme

    },

  },
  created(){
    
    console.log(window.location)

    this.URLPrefix = "https://" + window.location.hostname

    if(
      window.location.hostname == "127.0.0.1"
      || window.location.hostname == "localhost"
    ){
      this.URLPrefix = "https://krcl-studio.creek.org"
      // this.URLPrefix = "https://kzum-studio.creek.org"
    }

    // studioDomain.replace

    axios.get(this.URLPrefix + '/api/studio')
      .then((response) => {
        
        this.studio = response.data

        this.applyThemeToBody()

        this.refresh()

        // this.startRefreshInterval()

      })
  }
}

</script>